/**
 * Sunmed GA4 Tracking Module - PDP (Product Page)
 */

const SunmedTracking = {
  config: {
    debug: false,

    // GLOBAL SELECTORS (Standard DOM)
    selectors: {
        galleryImages: '.flickity-slider img', 
        reviewsBtn: '.jdgm-prev-badge', 
        surveyYes: '.yes-btn,[id^="yesTried"]',
        surveyNo: '.no-btn, [id^="noTried"]',
        buttonH: '.lab-report-link-button',
        buttonI: '#gaurantee-Back-tag',
        clickJ: '.btn-add-to-card-wrap .add-to-cart',
        clickK: '#swym-atw-pdp-button',
        videoPlayBtn: 'div[onclick]:has(img[alt="play video"])',
        accordionHeader: 'h2.description-header', 
        // NEW: Selectors for the Klaviyo Nudge
        nudgeReveal: '.sunmed-reveal-trigger',
        nudgeClick: '.sunmed-klaviyo-trigger'
    },

    // SHADOW DOM SELECTORS (Inside <skio-plan-picker>)
    shadowSelectors: {
        linkF: '.skio-frequency',
        linkG: '.open-modal-btn'
    },
    
    // Logic to check if Subscription is active (Checks both Old & New styles)
    isSubActive: function(shadowRoot) { 
       if (!shadowRoot) return false;
       
       // 1. Check Old Way (Class-based tabs)
       const legacyActive = shadowRoot.querySelector('.skio-subscribe-tab.skio-active');
       
       // 2. Check New Way (Radio Input Checked)
       const radioActive = shadowRoot.querySelector('.skio-native-radio[value="subscription"]:checked');

       // Returns true if EITHER is found
       return !!(legacyActive || radioActive);
    },
  },

  init: function() {
    if (this.config.debug) console.log('Sunmed PDP Tracking Initialized (v3.3)');
    
    this.bindGlobalClicks();
    this.waitForShadowHost();
    this.initGalleryObserver();
    this.initKlaviyoListener(); // NEW: Initialize Klaviyo Listener
  },

  pushEvent: function(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
      if (this.config.debug) console.log(`%c[GA4 Sent] ${eventName}`, 'color: #00C853; font-weight: bold;', params);
    }
  },

  // --- 1. GLOBAL LISTENER (Capture Phase) ---
  bindGlobalClicks: function() {
    document.body.addEventListener('click', (e) => {
      const s = this.config.selectors;
      const target = e.target;
      
      // J: Add to Cart (Now checks Skio state at moment of click)
      if (target.closest(s.clickJ)) {
        const skioHost = document.querySelector('skio-plan-picker');
        const root = skioHost ? skioHost.shadowRoot : null;
        const isSub = this.config.isSubActive(root);

        this.pushEvent('pdp_interaction', { 
            type: 'add_to_cart_click',
            status: isSub ? 'subscribe' : 'onetime'
        });
      }

      // K: Wishlist
      if (target.closest(s.clickK)) this.pushEvent('pdp_interaction', { type: 'wishlist_click' });

      // B: Reviews
      if (target.closest(s.reviewsBtn)) this.pushEvent('pdp_interaction', { type: 'reviews_cta_click' });

      // C & D: Survey
      if (target.closest(s.surveyYes)) this.pushEvent('pdp_interaction', { type: 'survey_click', interaction_value: 'yes' });
      if (target.closest(s.surveyNo)) this.pushEvent('pdp_interaction', { type: 'survey_click', interaction_value: 'no' });

      // H & I: Badges
      if (target.closest(s.buttonH)) this.pushEvent('pdp_interaction', { type: 'lab_results_click' });
      if (target.closest(s.buttonI)) this.pushEvent('pdp_interaction', { type: 'guarantee_badge_click' });
      
      // L: Video
      if (target.closest(s.videoPlayBtn)) this.pushEvent('video_engagement', { action: 'play' });
      
      // Accordions
      const acc = target.closest(s.accordionHeader);
      if (acc) this.pushEvent('accordion_expand', { section: acc.innerText.trim() });

      // --- NEW: Klaviyo Nudge Tracking ---
      
      // 1. Reveal click (opening the drawer)
      if (target.closest(s.nudgeReveal)) {
          this.pushEvent('pdp_interaction', { type: 'klaviyo_nudge_reveal_click' });
      }

      // 2. Popup click (clicking the actual "here" link to open popup)
      if (target.closest(s.nudgeClick)) {
          // Fire the GA4 Event for the Click
          this.pushEvent('klaviyo_nudge_click', {
              type: 'klaviyo_popup_opened'
          });
          // Set a session flag so we know they triggered the popup via the nudge
          sessionStorage.setItem('sunmed_nudge_active', 'true');
      }

    }, true);
  },

  // --- 2. SHADOW DOM HANDLER (The Fix) ---
  waitForShadowHost: function() {
      const poller = setInterval(() => {
          const host = document.querySelector('skio-plan-picker');
          if (host && host.shadowRoot) {
              clearInterval(poller);
              if (this.config.debug) console.log('[Tracking] Skio Widget Found.');
              this.attachShadowListener(host.shadowRoot);
          }
      }, 500); 
      setTimeout(() => clearInterval(poller), 10000);
  },

  attachShadowListener: function(root) {
      // Initialize memory of the state
      let lastKnownState = this.config.isSubActive(root);

      root.addEventListener('click', (e) => {
          const target = e.target;
          
          // --- A. STATE DIFF CHECK (Reliable Toggle Tracking) ---
          // Wait 50ms after ANY click in the widget to see if state changed
          setTimeout(() => {
              const currentState = this.config.isSubActive(root);
              
              if (currentState !== lastKnownState) {
                  this.pushEvent('pdp_interaction', { 
                      type: 'subscription_toggle', 
                      status: currentState ? 'subscribe' : 'onetime' 
                  });
                  lastKnownState = currentState; // Update memory
              }
          }, 50);

          // --- B. Other Links ---
          if (target.closest(this.config.shadowSelectors.linkF)) {
              this.pushEvent('pdp_interaction', { type: 'frequency_change_click' });
          }
          if (target.closest(this.config.shadowSelectors.linkG)) {
              this.pushEvent('pdp_interaction', { type: 'why_subscribe_click' });
          }

      }, true);
  },

  // --- 3. GALLERY OBSERVER ---
  initGalleryObserver: function() {
    setTimeout(() => {
        const images = document.querySelectorAll(this.config.selectors.galleryImages);
        if (images.length === 0) return;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = Array.from(images).indexOf(entry.target);
              this.pushEvent('gallery_view', { depth: index + 1 });
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.7 });

        images.forEach(img => observer.observe(img));
    }, 1500); 
  },

  // --- 4. KLAVIYO SUBMISSION LISTENER ---
  initKlaviyoListener: function() {
      window.addEventListener('klaviyoForms', (e) => {
          // Check if a form was submitted
          if (e.detail.type === 'submit') {
              // Check if they clicked our specific shortcode nudge in this session
              if (sessionStorage.getItem('sunmed_nudge_active') === 'true') {
                  this.pushEvent('klaviyo_nudge_signup', {
                      form_id: e.detail.formId
                  });
                  
                  // Clear the flag so we don't accidentally attribute future normal popups to the nudge
                  sessionStorage.removeItem('sunmed_nudge_active');
              }
          }
      });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => SunmedTracking.init());
} else {
  SunmedTracking.init();
}